import {test} from 'ramda';

import {registrationPlateRegex} from '../constants/registrationPlateRegex';

export const validateRegistrationPlate = (registrationPlate: string) =>
  test(registrationPlateRegex, registrationPlate);
